import 'reflect-metadata'

const metadataKey = Symbol('List')

export function List(): (target: object, propertyKey: string) => void {
  return registerProperty
}

function registerProperty(target: object, propertyKey: string): void {
  let properties: string[] = Reflect.getMetadata(metadataKey, target)

  if (properties) {
    properties.push(propertyKey)
  } else {
    properties = [propertyKey]
    Reflect.defineMetadata(metadataKey, properties, target)
  }
}

export function getListProperties<T>(origin: T): object {
  const properties: string[] = Reflect.getMetadata(metadataKey, origin)
  const result = {}
  properties.forEach((key) => (result[key] = origin[key]))
  return result
}
